export const FILTER_TYPE = {
  PREFIX: 1,
  AS: 2
};

export const MATCH_TYPE = {
  EXACT_ONLY: 1,
  MORE_SPECIFIC_ONLY: 2,
  EXACT_OR_MORE_SPECIFIC: 3
};

export const PREFIX_FILTER_TYPE = {
  PREFIX_ANNOUNCED_BY_ASN: 1,
  PREFIX_DELEGATED_TO_ACCOUNT: 2,
  PREFIX_SELECTED_INDIVIDUALLY: 3
};

export const AS_FILTER_TYPE = {
  AS_DELEGATED_TO_ACCOUNT: 4,
  AS_SELECTED_INDIVIDUALLY: 5
};

export const TRIGGER_TYPE = {
  ROA_OR_ROUTE_OBJECT_ALIGNMENT: 1,
  BGP_ANNOUNCEMENT_STATUS: 2
};

export const ALIGNMENT_TYPE = {
  MISMATCHED: 1,
  NOT_PUBLISHED: 2
};

export const BGP_ANNOUNCEMENT_TYPE = {
  ROUTE_EXISTS: 1,
  ROUTE_NOT_EXISTS: 2
};

export const SELECTED_ORIGIN_AS_TYPE = {
  ANY_DELEGATED_TO_ACCOUNT: 1,
  ANY_NOT_DELEGATED_TO_ACCOUNT: 2,
  INDIVIDUAL: 3
};

export const ACTION_CHANNEL_TYPE = {
  EMAIL: 1,
  SMS: 2,
  SLACK: 3
};

export const EMAIL_RECIPIENT_TYPE = {
  MYSELF: 1,
  MEMBER_CONTACT: 2,
  PROVIDED_ADDRESS: 3
};

export const RECIPIENT_TYPE_IN_API = {
  APNIC_USER: 'apnicUser',
  NON_APNIC_USER: 'nonApnicUser'
};

export const ROUTING_STATUS_ALERTS_REQUEST = {
  prefixFilter: {
    anyPrefixInMyOrigins: 'anyPrefixInMyOrigins',
    myAccountPrefixes: 'myAccountPrefixes'
  },
  exactOrMoreSpecific: {
    exact: 'exact',
    moreSpecific: 'moreSpecific',
    exactAndMoreSpecific: 'exactAndMoreSpecific'
  },
  originAsFilter: {
    allOriginsInMyAccount: 'allOriginsInMyAccount'
  },
  bgpAnnouncementStatus: {
    routeExists: 'routeExists',
    routeDoesntExist: 'routeDoesntExist'
  },
  bgpOriginAs: {
    anyOriginDelegated: 'anyOriginDelegated',
    anyOriginNotDelegated: 'anyOriginNotDelegated'
  },
  channel: {
    email: 'email',
    sms: 'sms',
    slack: 'slack'
  }
};

export const STATUS = {
  FIRING: 'Firing',
  FIRED: 'Fired',
  SNOOZED: 'Snoozed',
  CLEAN: 'Clean'
};

export const ALERT_SORT_OPTION = {
  NONE: 0,
  NAME_ASCENDING: 1,
  LAST_TRIGGER_NEWEST_FIRST: 2,
  LAST_TRIGGER_OLDEST_FIRST: 3
};

export const ALERT_FILTER_OPTION = {
  NONE: 0,
  FIRING: 1,
  FIRED: 2,
  SNOOZED: 3,
  CLEAN: 4
};

export const HISTORY_SORT_OPTION = {
  NONE: 0,
  NEWEST_FIRST: 1,
  OLDEST_FIRST: 2,
  TRIGGER_ASCENDING: 3,
  TRIGGER_DESCENDING: 4,
  REASON_ASCENDING: 5,
  REASON_DESCENDING: 6
};

export const HISTORY_FILTER_OPTION = {
  NONE: 0,
  HITS_IN_LAST_24_HOURS: 1,
  FIRST_HIT: 2,
  RESOLVED: 3
};

export const RESOURCE_NUMBER_SORT_OPTION = {
  NONE: 0,
  RESOURCE_NUMBER_ASCENDING: 1,
  RESOURCE_NUMBER_DESCENDING: 2
};

export const TRIGGER_SORT_OPTION = {
  NONE: 0,
  ORIGIN_AS_ASCENDING: 1,
  ORIGIN_AS_DESCENDING: 2
};

export const ACTION_SORT_OPTION = {
  NONE: 0,
  RECIPIENT_ASCENDING: 1,
  RECIPIENT_DESCENDING: 2
};

export const ACTION_FILTER_OPTION = {
  NONE: 0,
  EMAIL_ONLY: 1,
  SMS_ONLY: 2,
  SLACK_ONLY: 3
};

export const SHOW_MORE_MODAL_TYPE = {
  TRIGGERS: 'triggers',
  INCIDENT: 'incident',
  FILTERS: 'filters'
};

export const START_DATE_OF_ALERTS_ROUTING_STATUS = '2022-07-01';

export const MAX_TRIGGERS_SHOWN = 10;

export const MAX_INCIDENT_CHARACTERS_SHOWN = 120;

export const MAX_FILTERS_SHOWN = 10;
